<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="expenditure"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
      :date="date"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">
          Расход продуктов
        </h1>

        <btn-filters
          :data="data"
          endpoint="expenditure"
          v-model="filtersValue"
          :range="true"
          :date.sync="date"
        ></btn-filters>
      </div>
    </div>

    <data-table-full-height
      v-if="products && products.data"
      :data="products.data"
      :default-sort = "{prop: 'sum', order: 'descending'}"
    >
      <el-table-column prop="name" label="Продукт" min-width="200" max-width="360"/>
      <table-column-number align="right" sortable prop="count" label="Количество продаж"  min-width="64" max-width="108" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable prop="sum" label="Сумма продаж"  min-width="64" max-width="108" currencySymbol="₽" tableColumnType="number"/>
      <el-table-column label="Доля в продажах" min-width="360">
        <template slot-scope="{row}">
          <div class="d-flex align-items-center">
            <div style="width: 3em; text-align: right;" class="mr-3">
              {{ Math.round(row.count / (products.totalSales / 100)) }} %
            </div>
            <div class="progress flex-grow-1">
              <div
                class="progress-bar"
                role="progressbar"
                aria-valuemax="100"
                :style="'width:' + Math.round(row.count/(products.totalSales/100)) +'%;'"
              ></div>
            </div>
          </div>
        </template>
      </el-table-column>
    </data-table-full-height>
  </div>
</template>


<script>
  import moment from 'moment'

  export default {
    metaInfo: {title: 'Расход продуктов'},
    data () {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        sort: null,
        height: null,
        columns: null,
        date: {
          min: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          max: moment().format('YYYY-MM-DD'),
        },
      }
    },

    computed: {
      products () {
        return this.data
      },
    },
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/reports/expenditure.vue